import React, { useMemo } from 'react'
import {
  Typography, Grid, Paper,
  makeStyles, Theme, createStyles,
  FormControl, TextField,
  FormControlLabel, Checkbox, Button,
  CircularProgress,
  FormHelperText
} from "@material-ui/core";
import { green } from '@material-ui/core/colors';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      width: '80%'
    },
    form: {
      padding: theme.spacing(1),
    },
    mWidth: {
      marginTop: theme.spacing(1),
      maxWidth: "80%",
      minWidth: "40%"
    },
    lWidth: {
      marginTop: theme.spacing(1),
      width: "100%",
    },
    chips: {
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(1),
    },
    button: {
      margin: theme.spacing(1),
    },
    wrapper: {
      position: 'relative',
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
  }),
);

interface Prop {
  handleChangeForm: (event: React.ChangeEvent<{
    value: unknown;
    name?: string | undefined;
  }>) => void,
  form: {
    userCd: string,
    userName: string;
    departmentName: string;
    emailAddress1: string;
    telephoneNumber: string;
    post: string,
    url: boolean
  },
  emailc: boolean,
  telc: boolean,
  loading: boolean,
  onSubmit: () => void
  handleChangeChecked: (event: React.ChangeEvent<HTMLInputElement>) => void,
  reqItem: {
    userName: boolean;
    emailAddress1: boolean;
    telephoneNumber: boolean;
  }
}

const UserCreateForm: React.FC<Prop> = (props) => {
  const classes = useStyles()
  const { loading, handleChangeForm, form, telc, emailc, onSubmit, handleChangeChecked, reqItem } = props

  const checkPipeLineDepartment = form.departmentName.match(/\|/) ? true : false
  const checkPileLinePost = form.post.match(/\|/) ? true : false
  const emailcheck = useMemo(() => {
    if (emailc || reqItem.emailAddress1) {
      return true
    } else {
      return false
    }
  }, [emailc, reqItem.emailAddress1])

  const telcheck = useMemo(() => {
    if (telc || reqItem.telephoneNumber) {
      return true
    } else {
      return false
    }
  }, [telc, reqItem.telephoneNumber])

  const check = form.userName.length * form.telephoneNumber.length * form.emailAddress1.length === 0 ? true : telcheck ? true : emailcheck ? true : checkPipeLineDepartment ? true : checkPileLinePost ? true : loading ? true : false

  return (
    <React.Fragment>
      <Paper>
        <form className={classes.form}>
          <Grid container direction="row" justify="center" alignItems="center">
            <Paper elevation={0} className={classes.paper}>
              <Grid item xs={12}>
                <FormControl className={classes.mWidth} margin="dense" variant="outlined" error={reqItem.userName}>
                  <TextField id="userName" variant="outlined" name="userName" label="氏名" size="small" required value={form.userName} onChange={handleChangeForm} error={reqItem.userName} />
                  {reqItem.userName && <FormHelperText error>必須項目です</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl className={classes.mWidth} margin="dense" variant="outlined">
                  <TextField id="departmentName" variant="outlined" name="departmentName" label="所属部署名" size="small" onChange={handleChangeForm} value={form.departmentName} error={checkPipeLineDepartment} />
                  {checkPipeLineDepartment && <FormHelperText error>「|」は使用できません</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl className={classes.mWidth} margin="dense" variant="outlined">
                  <TextField id="post" variant="outlined" name="post" label="役職" size="small" value={form.post} onChange={handleChangeForm} error={checkPileLinePost} />
                  {checkPipeLineDepartment && <FormHelperText error>「|」は使用できません</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl className={classes.mWidth} margin="dense" variant="outlined" error={emailcheck}>
                  <TextField id="emailAddress1" variant="outlined" name="emailAddress1" label="E-mailアドレス" size="small" required error={emailcheck} value={form.emailAddress1} onChange={handleChangeForm} />
                  {emailcheck && <FormHelperText error>メールアドレスを入力してください</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl className={classes.mWidth} margin="dense" variant="outlined" error={telcheck}>
                  <TextField id="telephoneNumber" variant="outlined" value={form.telephoneNumber} name="telephoneNumber" label="電話番号" size="small" required onChange={handleChangeForm} error={telcheck} />
                  {telcheck ? <FormHelperText error>‐を含め,10-11桁の数値を入力してください</FormHelperText> : <FormHelperText>入力例 000-000-0000</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={<Checkbox checked={form.url} onChange={handleChangeChecked} size="small" name="url" color="primary" />
                  }
                  labelPlacement="start"
                  label="代表者"
                />
              </Grid>
              <Grid item xs={12}>
                <Grid container justify="center" direction="column" alignItems="center">
                  <Grid item>
                    <div className={classes.wrapper}>
                      <Button variant="contained" color="primary" size="large"
                        className={classes.button}
                        disabled={check}
                        onClick={onSubmit}>
                        作成
                    </Button>
                      {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>
                  </Grid>
                  <Grid item>
                    {check && !loading && <Typography color='error' variant="caption">{`未入力の必須項目かエラーがあります`}</Typography>}
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </form>
      </Paper>
    </React.Fragment>
  )
}
export default UserCreateForm